export enum ChunkHashAlgorithm {
	Sha256 = 'sha256',
}
